var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBackArrow = function SvgBackArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 9,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.202 4.269a.5.5 0 0 0 0 .707l3.182 3.182a.5.5 0 0 0 .707-.708L1.262 4.622l2.829-2.828a.5.5 0 0 0-.707-.707L.202 4.269Zm40.353-.147h-40v1h40v-1Z",
    fill: "#fff"
  })));
};
export default SvgBackArrow;